import { render, staticRenderFns } from "./orDetails.vue?vue&type=template&id=2fbfb6f9&scoped=true"
import script from "./orDetails.vue?vue&type=script&lang=js"
export * from "./orDetails.vue?vue&type=script&lang=js"
import style0 from "./orDetails.vue?vue&type=style&index=0&id=2fbfb6f9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fbfb6f9",
  null
  
)

export default component.exports